import React, { useState, useEffect, useRef } from "react";
import Label from "./Label";

const DropdownSelector = ({
  options = [],
  onSelect,
  defaultValue,
  sectionClass,
  placeholder,
  name,
  value,
  id,
  disabled,
  addDisabled,
  addClick,
  handleRemoveZone,
  zoneSelectDropDown,
  tabIndex = 0,
  addTabIndex,
  'data-testid': dataTestId,
}) => {
  const testId = dataTestId || `dropdown-selector-${id}`;
  const isAddDisabled = addDisabled ?? disabled;
  const [isOpen, setIsOpen] = useState(false);
  const isControlled = value !== undefined;
  const [selected, setSelected] = useState(null);
  const currentValue = isControlled ? value : selected;
  const dropdownRef = useRef(null);

  console.log("building selected", selected)

  const computedOptions =
    id === "bulding" && selected && Object.keys(selected).length > 0 && selected.name !== null
      ? [{ name: "Remove Building", isRemove: true }, ...options]
      : options;

  const toggleDropdown = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  const handleSelect = (item) => {
    if (item?.isRemove) {
      handleRemoveZone?.();
      if (!isControlled) setSelected(null);
      setIsOpen(false);
      onSelect(null);
      return;
    }

    if (!isControlled) {
      setSelected(item);
    }
    onSelect(item);
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isControlled) {
      setSelected(defaultValue);
    }
  }, [defaultValue, isControlled]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

   console.log("currentValue",currentValue)

  return (
    <div className={sectionClass}>
      <div className="flex flex-col gap-1">
        <Label
          htmlFor={id}
          className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
        >
          {name} <span className='text-theme'>{sectionClass === "propertysection" ? "*" : ""}</span>
        </Label>
        <div className="flex items-center gap-4">
          <div
            className={`flex items-center gap-2 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey h-11 bg-white md:w-[272px] sm:w-56 w-full relative group shrink sm:shrink-0 dark:darkThemeGradiantBg dark:text-white dark:border-none placeholder:text-dark-grey/40 dark:placeholder:text-white/40 ${disabled ? "pointer-events-none opacity-40" : ""
              }`}
            ref={dropdownRef}
          >
            <div
              id="pod"
              data-testid={`${testId}-trigger`}
              className="w-full flex justify-between items-center cursor-pointer gap-2"
              onClick={toggleDropdown}
              role="button"
              tabIndex={disabled ? -1 : tabIndex}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  toggleDropdown();
                }
              }}
            >
              <div className="dropdownValue text-base leading-5 lg:text-lg xl:leading-6 font-medium tracking-[-0.408px] grow truncate w-32">


                {selected?.name || placeholder}


              </div>
              <div className="dropdownIconHolder cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.92 8.9502L13.4 15.4702C12.63 16.2402 11.37 16.2402 10.6 15.4702L4.08002 8.9502"
                    stroke="#FF8C65"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>

            {isOpen && (
              <div className="dropdownMenuHolder absolute top-full left-0 right-0 shadow-appShadow dark:shadow-darkThemeDropdownMenuShadow w-full mt-2 rounded-md z-50 max-h-60 overflow-y-auto">
                <ul className="bg-white dark:bg-darkThemeDropdownBg rounded-lg w-full">
                  {computedOptions?.map((item, index) => (
                    <li
                      key={index}
                      data-testid={`${testId}-option-${index}`}
                      className={`px-3 py-2.5 cursor-pointer tracking-[-0.408px] border-b border-grey dark:border-darkThemeBorder flex justify-between items-center gap-2 
                        ${item?.isRemove ? "text-theme font-semibold text-base leading-6 text-center border border-theme rounded-tl-lg rounded-tr-lg" : "text-dark-grey dark:text-white text-left font-normal text-xs lg:text-sm leading-4 lg:leading-5"}
                        ${currentValue === item ? "bg-[#FFF1C6] dark:bg-darkThemeDropdownItemBg" : ""
                        }`}
                      onClick={() => handleSelect(item)}
                    >
                      <span className="w-full line-clamp-2 break-words text-ellipsis">{item?.name}</span>
                      {currentValue === item && (
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M8.49215 15C8.24102 15 8.00244 14.8995 7.82665 14.7238L4.27311 11.1702C3.90896 10.8061 3.90896 10.2033 4.27311 9.8392C4.63725 9.47506 5.23997 9.47506 5.60412 9.8392L8.49215 12.7272L14.9463 6.27311C15.3104 5.90896 15.9132 5.90896 16.2773 6.27311C16.6414 6.63725 16.6414 7.23997 16.2773 7.60412L9.15766 14.7238C8.98186 14.8995 8.74329 15 8.49215 15Z"
                              fill="#FF8C65"
                            />
                          </svg>
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div className="addIconHolder flex justify-center items-center basis-10 shrink-0">
            <button
              data-testid={`${testId}-add`}
              className={`text-theme text-base font-semibold leading-6 ${
                isAddDisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={(event) => {
                if (isAddDisabled) return;
                addClick?.(event);
              }}
              disabled={isAddDisabled}
              tabIndex={addTabIndex}
            >
              Add
            </button>
          </div>
          {selected && zoneSelectDropDown && (
            <div className="removeIconHolder flex justify-center items-center basis-10 shrink-0">
              <button
                data-testid={`${testId}-remove`}
                className={`text-theme text-base font-semibold leading-6 ${
                  disabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
                onClick={() => {
                  if (disabled) return;
                  handleRemoveZone?.();
                }}
                disabled={disabled}
              >
                Remove
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DropdownSelector;
